/**
 * assets/variant-swatch-tooltip.js — AJOUT 2026-08-21
 *
 * Info-bulle au survol des pastilles (images / swatches) du sélecteur de variantes
 * de la page produit : nom de la valeur + disponibilité de la variante correspondante.
 *
 * - Desktop uniquement : n'est actif que si le pointeur sait survoler
 *   (media query "(hover: hover) and (pointer: fine)").
 * - Aucune requête réseau supplémentaire : le statut est rendu par Liquid dans l'attribut
 *   data-stock-status de chaque input .js-option (product_option_value.variant = variante de la
 *   valeur combinée à la sélection courante), et rafraîchi par variant-picker.js à chaque
 *   changement d'option (Section Rendering API).
 *   MODIF 2026-09-07 (high-variant) : remplace l'ancienne map JSON plafonnée à 250 variantes.
 */
(() => {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!canHover.matches) return;

  const initPicker = (picker) => {
    if (picker.dataset.swatchTooltipInit) return;
    if (!picker.querySelector('.opt-label--swatch')) return;
    picker.dataset.swatchTooltipInit = 'true';

    const tooltip = document.createElement('div');
    tooltip.className = 'variant-swatch-tooltip';
    tooltip.setAttribute('role', 'tooltip');
    tooltip.hidden = true;
    tooltip.innerHTML = '<span class="variant-swatch-tooltip__name"></span><span class="variant-swatch-tooltip__stock"></span>';
    document.body.appendChild(tooltip);
    const nameEl = tooltip.querySelector('.variant-swatch-tooltip__name');
    const stockEl = tooltip.querySelector('.variant-swatch-tooltip__stock');

    const position = (label) => {
      const rect = label.getBoundingClientRect();
      const gap = 8;
      tooltip.hidden = false;
      const tipRect = tooltip.getBoundingClientRect();
      let left = rect.left + rect.width / 2 - tipRect.width / 2;
      const margin = 8;
      left = Math.max(margin, Math.min(left, window.innerWidth - tipRect.width - margin));
      let top = rect.top - tipRect.height - gap;
      tooltip.classList.toggle('variant-swatch-tooltip--below', top < margin);
      if (top < margin) top = rect.bottom + gap;
      // Position de la flèche : centrée sur la pastille
      const arrowX = rect.left + rect.width / 2 - left;
      tooltip.style.setProperty('--arrow-x', `${arrowX}px`);
      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${top}px`;
    };

    const show = (label) => {
      const input = picker.querySelector(`#${CSS.escape(label.htmlFor)}`);
      if (!input) return;
      const value = input.value;

      nameEl.textContent = value;
      let stock = input.dataset.stockStatus || '';
      if (!stock && input.dataset.exists === 'false' && window.theme && theme.strings && theme.strings.noVariant) {
        stock = theme.strings.noVariant;
      }
      stockEl.textContent = stock;
      stockEl.hidden = !stock;
      position(label);
    };

    const hide = () => {
      tooltip.hidden = true;
    };

    picker.addEventListener('mouseover', (evt) => {
      const label = evt.target.closest('.opt-label--swatch');
      if (label && picker.contains(label)) show(label);
    });
    picker.addEventListener('mouseout', (evt) => {
      const label = evt.target.closest('.opt-label--swatch');
      if (label && !label.contains(evt.relatedTarget)) hide();
    });
    // Masquer si on change de variante / scrolle, pour éviter une bulle orpheline
    picker.addEventListener('change', hide);
    window.addEventListener('scroll', hide, { passive: true });
  };

  const initAll = () => {
    document.querySelectorAll('variant-picker').forEach(initPicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Pickers ajoutés plus tard (quick-add, rechargement de section)
  new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
